import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.string.includes";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MagneticToCursor = /*#__PURE__*/function () {
  function MagneticToCursor(node, startingBreakpoint) {
    _classCallCheck(this, MagneticToCursor);

    this.node = node;
    this.startingBreakpoint = startingBreakpoint;
    this.distanceX = node.getBoundingClientRect().width;
    this.distanceY = node.getBoundingClientRect().height;
    this.mouseHasEntered = false;
    this.mouseIsInButtonTerritory = false;
    this.handleMove = this.handleMove.bind(this);
  }

  _createClass(MagneticToCursor, [{
    key: "onClick",
    value: function onClick(e) {
      console.log(e);

      if (e.target.getAttribute('href') && e.target.getAttribute('href').includes('#')) {
        e.preventDefault();
        document.querySelector(e.target.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, {
    key: "handleEvent",
    value: function handleEvent() {
      var _this = this;

      this.node.addEventListener('click', function (e) {
        return _this.onClick(e);
      });
      this.node.addEventListener('mouseenter', function () {
        window.addEventListener('mousemove', _this.handleMove, true);
      });
      this.node.addEventListener('mouseleave', function () {
        _this.handleReset();

        window.removeEventListener('mousemove', _this.handleMove, true);
      });
    }
  }, {
    key: "handleMove",
    value: function handleMove(e) {
      var x = e.x,
          y = e.y;
      var leftBorderLine = this.centerPointX - this.distanceX;
      var rightBorderLine = this.centerPointX + this.distanceX;
      var topBorderLine = this.centerPointY - this.distanceY;
      var bottomBorderline = this.centerPointY + this.distanceY;
      this.xWalk = (x - this.centerPointX) / 6;
      this.yWalk = (y - this.centerPointY) / 6;
      this.mouseIsInButtonTerritory = x > leftBorderLine && x < rightBorderLine && y > topBorderLine && y < bottomBorderline;

      if (this.mouseIsInButtonTerritory) {
        if (!this.mouseHasEntered) {
          this.distanceX = this.node.getBoundingClientRect().width;
          this.distanceY = this.node.getBoundingClientRect().height;
          this.mouseHasEntered = true;
        }

        this.handleCatch();
      } else {
        this.handleReset();
      }
    }
  }, {
    key: "handleCatch",
    value: function handleCatch() {
      // translates the button in the direction where cursor is.
      this.node.style.transform = "translate(".concat(this.xWalk, "px, ").concat(this.yWalk, "px)");
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      // resets the position of the button as it was initial.
      this.node.style.transform = "translate(".concat(0, "px, ", 0, "px)");

      if (this.mouseHasEntered) {
        this.distanceX = this.node.getBoundingClientRect().width;
        this.distanceY = this.node.getBoundingClientRect().height;
      }

      this.mouseHasEntered = false;
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      var _this$node$getBoundin = this.node.getBoundingClientRect(),
          width = _this$node$getBoundin.width,
          height = _this$node$getBoundin.height,
          x = _this$node$getBoundin.x,
          y = _this$node$getBoundin.y; // gives width, height, left-x,top-y of the button


      var centerPointX = x + width / 2; //  center point of button on x-axis

      var centerPointY = y + height / 2; //  center point of button on y-axis

      this.centerPointX = centerPointX;
      this.centerPointY = centerPointY;
    }
  }, {
    key: "init",
    value: function init() {
      if (window.matchMedia("(min-width: ".concat(this.startingBreakpoint, "px)")).matches) {
        this.onLoad();
        this.handleEvent();
      }
    }
  }]);

  return MagneticToCursor;
}();

export default MagneticToCursor;